import { LoaderService } from '@app/shared/services/loader.service';
import { AppConstant } from '@app/configs/app.constant';
import { AlertService } from '@app/core/services/alert.service';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { SigningHubService } from '@app/core/services/signing-hub.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface IFileSource {
  name: string;
  file: File;
  base64: string;
  slot: string;
  password: string;
}

@Component({
  selector: 'app-pkcs12-uploader',
  templateUrl: './pkcs12-uploader.component.html',
  styleUrls: ['./pkcs12-uploader.component.css'],
})
export class Pkcs12UploaderComponent implements OnInit {
  public fileUploadForm!: FormGroup;
  public name!: FormControl;
  public file!: FormControl;
  public fileName!: FormControl;
  public fileSource!: FormControl;
  public password!: FormControl;
  public slot: FormControl;
  public isSubmit: boolean;

  public pkcs12slots: string[] = [];
  public isLoading: Subject<boolean> = this.loaderService.isLoading;

  @Output() fileChange = new EventEmitter<IFileSource | undefined>();

  constructor(
    private signingHubService: SigningHubService,
    private loaderService: LoaderService,
    private alertService: AlertService,
    private translate : TranslateService
  ) {}

  ngOnInit(): void {
    this.file = new FormControl('', [Validators.required]);
    this.fileName = new FormControl('', [Validators.required]);
    this.fileSource = new FormControl('', [Validators.required]);
    this.slot = new FormControl('', [Validators.required]);
    this.password = new FormControl('', [Validators.required]);
    this.fileUploadForm = new FormGroup({
      file: this.file,
      fileName: this.fileName,
      fileSource: this.fileSource,
      slot: this.slot,
      password: this.password,
    });
  }

  pcks12ToBase64(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();

    reader.readAsBinaryString(file);
    reader.onload = (event) =>
      result.next(btoa(event.target.result.toString()));

    return result;
  }

  async onGetPKCS12Slot() {
    this.isSubmit = true;

    if (this.password.invalid) {
      this.alertService.warn(this.translate.instant('WARN.enterACertificatePassword'));
      return false;
    }

    this.pcks12ToBase64(this.fileSource.value).subscribe((base64) => {
      this.signingHubService
        .getPKCS12Slot(base64, this.password.value)
        .subscribe({
          next: (v) => {
            if (v.code == AppConstant.HTTP_STATUS_CODE_SUCCESS) {
              this.pkcs12slots = v.data;
            } else {
              console.log(v);
              var message = ['keystore password was incorrect'].includes(v.message) ? this.translate.instant('CERERROR.' + v.message) : v.message; 
              this.alertService.error(
                `${this.translate.instant('ERROR.cannotGetTheSlotOfCertificate')} ${message}`
              );
            }
          },
          error: (e) => {
            console.error(e);
            this.alertService.error(this.translate.instant('ERROR.cannotGetTheSlotOfCertificate'));
          },
        });
    });
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      this.fileChange.emit(undefined);
      const file: File = event.target.files[0];
      this.fileName.patchValue(file.name);
      this.fileSource.patchValue(file);
      this.password.reset('');
      this.slot.reset('');
      this.pkcs12slots = [];
    }
  }

  onSlotChange() {
    this.pcks12ToBase64(this.fileSource.value).subscribe((base64) => {
      this.fileChange.emit(<IFileSource>{
        name: this.fileName.value,
        file: this.fileSource.value,
        base64: base64,
        password: this.password.value,
        slot: this.slot.value,
      });
    });
  }
}
